var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.996,
    height: 57.926,
    viewBox: "0 0 152.996 57.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3091",
    "data-name": "Group 3091",
    transform: "translate(-122.837 -267.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    transform: "translate(122.837 267.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056",
    transform: "translate(0.748 8.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M128.049,319.569h-4.212V294.055h4.212Z",
    transform: "translate(-123.837 -282.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2816",
    "data-name": "Path 2816",
    d: "M162.627,319.352h-4.162V303.845c0-3.914-2.18-6.788-6.242-6.788a6.51,6.51,0,0,0-6.688,6.688v15.606h-4.211V293.838h4.062v2.774a9.4,9.4,0,0,1,7.432-3.419c6.242,0,9.809,4.459,9.809,10.8Z",
    transform: "translate(-128.245 -282.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2817",
    "data-name": "Path 2817",
    d: "M189.347,320c-6.192,0-10.7-3.319-11.4-8.72h4.262c.545,2.972,3.468,4.806,7.133,4.806,3.964,0,6.391-1.933,6.391-4.162,0-1.784-.693-3.121-6.937-3.963-6.192-.892-9.957-2.379-9.957-7.184,0-3.666,3.171-7.581,10.008-7.581,5.9,0,9.859,2.973,10.4,7.977H195c-.595-2.725-3.022-4.112-6.144-4.112-3.369,0-5.8,1.586-5.8,3.567,0,1.833,1.438,2.477,6.441,3.27,5.648.892,10.3,1.981,10.3,7.778C199.8,316.776,195.441,320,189.347,320Z",
    transform: "translate(-137.477 -282.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M219.72,319.569h-4.211V294.055h4.211Z",
    transform: "translate(-146.943 -282.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2819",
    "data-name": "Path 2819",
    d: "M255.412,318.163c0,8.174-5.3,13.723-13.129,13.723-6.044,0-10.75-3.221-12.039-8.423h4.409c1.684,3.815,5.747,4.36,7.63,4.36,6.54,0,8.918-5.053,8.918-9.661v-2.675a11.016,11.016,0,0,1-8.67,4.509c-7.333,0-12.782-5.995-12.782-13.377s5.449-13.427,12.782-13.427a10.976,10.976,0,0,1,8.818,4.707v-4.062h4.063Zm-12.881-21.056c-4.806,0-8.571,4.261-8.571,9.562,0,5.2,3.765,9.463,8.571,9.463,4.707,0,8.67-4.26,8.67-9.463C251.2,301.368,247.238,297.107,242.531,297.107Z",
    transform: "translate(-150.532 -282.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2820",
    "data-name": "Path 2820",
    d: "M295.572,315.746h-4.162V300.239c0-3.963-2.13-6.788-6.242-6.788a6.51,6.51,0,0,0-6.688,6.688v15.606h-4.211v-36.86h4.211v13.922a9.486,9.486,0,0,1,7.283-3.221c6.242,0,9.809,4.459,9.809,10.8Z",
    transform: "translate(-161.753 -278.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M322.832,317.733c-5.945.694-10.057-2.824-10.057-9.313V296.231h-3.468v-4.013h3.468v-5.45h4.161v5.45h5.8v4.013h-5.8v12.188c0,4.508,2.775,5.648,5.9,5.45Z",
    transform: "translate(-170.584 -280.873)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2822",
    "data-name": "Path 2822",
    d: "M202.683,278.561a2.688,2.688,0,0,0-4.63-.645l-30.584.936-2.961-7.456a2.479,2.479,0,1,0-4.492-1.3l-12.182,8.857a.924.924,0,0,0-.936-.153.934.934,0,0,0,.7,1.732.917.917,0,0,0,.545-.671l17.483.486,12.863,28.888a8.783,8.783,0,0,0,1.158.283l-11.56-29.1,29.967.833a2.7,2.7,0,0,0,4.626-2.684Zm-54.543.881a.807.807,0,0,0-.025-.131.9.9,0,0,0-.079-.118l12.93-7.278a2.476,2.476,0,0,0,1.129.492l2.9,6.52Z",
    transform: "translate(-128.755 -267.479)",
    fill: "#95becc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2823",
    "data-name": "Path 2823",
    d: "M128.054,281.726a2.707,2.707,0,1,0-2.286,3.7l28.072,22.237v-2.354l-25.62-22.24A2.68,2.68,0,0,0,128.054,281.726Z",
    transform: "translate(-122.837 -270.644)",
    fill: "#95becc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2824",
    "data-name": "Path 2824",
    d: "M192.054,337.02a.927.927,0,0,0-.9-.574l-3.959-9.967c-.286,0-.57-.012-.849-.028l4.48,10.062a.908.908,0,0,0-.232.154l-20.741-18.005V320.7l20.514,16.251a.92.92,0,0,0-.044.773.934.934,0,1,0,1.732-.7Z",
    transform: "translate(-134.687 -280.38)",
    fill: "#95becc"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightLogo);
export default __webpack_public_path__ + "static/media/insightLogo.4b8bc23c.svg";
export { ForwardRef as ReactComponent };